import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RiderNotesComponent } from './rider-notes.component';
import { RiderNotesService } from './rider-notes.service';
import { Trip2ThemeModule } from '../../../trip2-theme/trip2-theme.module';
import {AgGridModule} from 'ag-grid-angular';
import { AddRiderNoteComponent } from './add-rider-note/add-rider-note.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        Trip2ThemeModule,
        AgGridModule.withComponents([
        ])
    ],
    declarations: [RiderNotesComponent, AddRiderNoteComponent],
    exports: [
        RiderNotesComponent
    ],
    providers: [
        RiderNotesService
    ]
})
export class RiderNotesModule { }



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-notes/rider-notes.module.ts